<div class="questions">
    <p v-for="(question, index) in questions">{{ index + 1 }}. {{ question }}</p>
</div>
